import LiveTipModalComponent from "./LiveTipModalComponent";

export default LiveTipModalComponent